<template>
    <div style="font-size: 23.4375px;">
        <!--    导航栏-->
        <Anav pro="2"></Anav>
        <!--    标签栏-->
        <Atablebar></Atablebar>
        <div style="height: 3rem"></div>
        <div class="box">
<!--            搜索-->
<!--            <div class="search-box">-->
<!--                <div class="search-box-center">-->
<!--                    <div>请输入关键字...</div>-->
<!--                    <div><van-icon style="line-height: 50px" name="search" /></div>-->
<!--                </div>-->
<!--            </div>-->

<!--            常见问题-->
            <div class="problem-type" >
                <div class="problem-type-center">
                    <div class="problem-item" @click="askpreblom(5)">保险产品</div>
                    <div class="problem-item" @click="askpreblom(6)">参保流程</div>
                    <div class="problem-item" @click="askpreblom(7)">理赔流程</div>
                    <div class="problem-item" @click="askpreblom(8)">关于我们</div>
                </div>
            </div>
            <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="height: 450px;overflow: auto;background: white">
                 <van-list
                         v-model="isUpLoading"
                         :finished="upFinished"
                         @load="onLoads"
                         :offset="offset" :immediate-check="false"
                 >-->
                    <div class="boxDiv" >
                        <van-collapse v-model="item.problemId" accordion v-for="(item,index) in asblist" :key="index" >
                            <van-collapse-item  :title="item.problem" name="1"><div v-html="item.answer"></div></van-collapse-item>
                        </van-collapse>
                    </div>
                <!--</van-list>
            </van-pull-refresh>-->
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Icon, Toast,List,Collapse, CollapseItem,PullRefresh} from 'vant';
    //引入导航组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';
    // 引入icon
    import icon_list_1 from '@/views/anshibao/icon/AhomeIcon/icon_list_1.png';
    import icon_list_2 from '@/views/anshibao/icon/AhomeIcon/icon_list_2.png';
    import icon_list_3 from '@/views/anshibao/icon/AhomeIcon/icon_list_3.png';
    import icon_list_4 from '@/views/anshibao/icon/AhomeIcon/icon_list_4.png';
    import icon_list_5 from '@/views/anshibao/icon/AhomeIcon/icon_list_5.png';
    import icon_list_6 from '@/views/anshibao/icon/AhomeIcon/icon_list_6.png';
    Vue.use(Field).use(Button).use(Notify).use(List).use(Collapse).use(CollapseItem).use(PullRefresh);
    Vue.use(Icon);
    export default {
        components:{
            Anav,
            Atablebar,
        },

        name: "Login",
        data() {
            return {
                asblist:"",
                isLoading: false,
                isUpLoading:false,//上拉加载
                upFinished:false,//上拉加载完毕
                offset:100,//滚动条与底部距离小于 offset 时触发load事件,
                page:1
            }
        },
        props: {
            name: {}
        },
        mounted() {
            //上来不需要调用
            // this.askpreblom2();
        },
        methods: {
            askpreblom2(){
                this.$axios.post("/product/problem?problemType=&problemName=&page="+this.page+"&pageSize=7").then(res=>{
                    if(res.data==0){
                        Notify({ type: 'danger', message: '没有匹配内容！'})
                    }
                    this.asblist=res.data
                })
            },
            askpreblom(n){
                this.$router.push("/Aproblemdetail?type=0&problemid="+n)
            },
            onRefresh() {
                setTimeout(() => {
                    Toast('刷新成功');
                    this.isLoading = false;
                }, 1000);
            },
            /*onLoads () { // 上拉调用此函数
                setTimeout(() => {
                    this.isUpLoading = false;
                    this.$axios.post("/product/problem?problemType=&problemName=&page="+(++this.page)+"&pageSize=7").then(res=>{
                        if(res.data.length>0){
                            Toast('加载成功');//弹出
                            for(var i=0;i<res.data.length;i++){
                                this.asblist.push(res.data[i])
                            }
                            console.log(this.asblist)
                        }else {
                            Toast('没有更多数据了');//弹出

                            this.upFinished = true;
                        }
                    })
                }, 1000);
            },*/
        }
    }
</script>

<style scoped>
    .box{
        padding-top: 20px;
    }
    .search-box{
        width: 100%;
        background-color: #fff;
        margin: 0 0 20px;
        border: 1px solid #fff;
    }
    .boxDiv{
        background: white;
        padding-left: 20px;
        padding-right: 20px;
    }
    .search-box .search-box-center{
        /*margin: 20px auto;*/
        width: 92vw;
        margin: 20px auto;
        background-color: #FFF;
        height: 50px;
        line-height: 50px;
        overflow: hidden;
        border-radius: 4px;
        box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
    }
    .search-box .search-box-center div:first-child{
        height: 50px;
        padding-left: 4vw;
        float: left;
        font-size: 20px;
        color: #919191;
    }
    .search-box .search-box-center div:nth-child(2){
        height: 50px;
        padding-left: 6vw;
        float: right;
        font-size: 28px;
        color: rgb(170, 170, 170);
        margin-right: 4vw;
    }

    /*四个按钮*/
    .problem-type{
        background-color: #fff;
        width: 100%;

    }
    .problem-type .problem-type-center{
        width: 88vw;
        padding: 30px 0 0;
        margin: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .problem-type .problem-type-center div{;
        background-color: #fff;
        width: 41vw;
        text-align: center;
        font-size: 1rem;
        line-height: 3rem;
        margin-bottom: 30px;
        color: #333;
        border: 1px solid #dbdbdb;
    }
</style>
